export default __webpack_public_path__ + "static/media/crystal_card_background.ce8229ff.png";